import { HttpClassBase } from 'common-http/index';
import { nanoid } from 'nanoid';

import logger from '../helpers/logger';
import { checkResData } from './lang-base';

const TAG = 'RequestBase';

class RequestBase extends HttpClassBase {
  static instance;
  static getInstance() {
    if (!RequestBase.instance) {
      RequestBase.instance = new RequestBase();
    }
    return RequestBase.instance;
  }

  static getData(data) {
    const headerConfig = { headerConfig: { 'x-req-id': nanoid(10) } };
    return { ...data, ...headerConfig };
  }

  callBase({ fullPath, data, options = {} }) {
    const call = async () => {
      try {
        return await this.commonHttpCall({ fullPath, data: RequestBase.getData(data), options })
          .then(async (res) => {
            logger.debug(TAG, { fullPath, data, options, res });

            const result = await checkResData({ res, fullPath, data, options: {} });

            const resData = result.data;

            // 修复数据结构不一致问题
            const response = resData?.data ? resData : result;

            return response;
          })
          .catch((err) => {
            logger.error(TAG, err);
            throw err;
          });
      } catch (err) {
        // 此处进行错误处理
        logger.error(TAG, err);
        throw err;
      }
    };
    return call();
  }
}

const requestBaseInstance = RequestBase.getInstance();

export default requestBaseInstance;
